import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "mainSection"
};
const _hoisted_2 = ["id"];
const _hoisted_3 = {
  class: "bal-after"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "bal-before"
};
const _hoisted_6 = {
  class: "bal-before-inset"
};
const _hoisted_7 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(), _createElementBlock("div", {
    key: $data.pluginKey,
    ref: "beforeAfterContainer",
    id: `beforeAfter-${$data.pluginKey}`,
    class: "bal-container"
  }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    onLoad: _cache[0] || (_cache[0] = (...args) => $options.onImageLoad && $options.onImageLoad(...args)),
    src: $props.before,
    alt: "Before Image"
  }, null, 40, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
    onLoad: _cache[1] || (_cache[1] = (...args) => $options.onImageLoad && $options.onImageLoad(...args)),
    src: $props.after,
    alt: "After Image"
  }, null, 40, _hoisted_7)])]), _cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "bal-handle"
  }, [_createElementVNode("span", {
    class: "handle-left-arrow"
  }), _createElementVNode("span", {
    class: "handle-right-arrow"
  })], -1))], 8, _hoisted_2))]);
}